import { render, staticRenderFns } from "./base-bar-horizontal-chart-commercialisation.vue?vue&type=template&id=1b98b33a"
import script from "./base-bar-horizontal-chart-commercialisation.vue?vue&type=script&lang=js"
export * from "./base-bar-horizontal-chart-commercialisation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports